<template>
  <div class="col-sm-12">
    <h3 class="info-text">
      ID Verification
    </h3>
    <p>
      To proceed with your application, we need to verify your identity. Please
      click on the link below or scan the QR code with your mobile device to
      start the verification process.
    </p>
    <div
      v-if="gbgData.imageUrl"
      class="row"
      :key="'IDContent_' + contact.contactId"
    >
      <div class="col-sm-12">
        <div class=" clearfix text-center">
          <a
            :href="gbgData.linkUrl"
            target="_blank"
            class="btn btn-fill btn-success btn-wd btn-md btn-anchor"
            >Click here</a
          >
          <br /><br />
          <p>Or</p>
          <p>Scan the QR code:</p>
          <img :src="gbgData.imageUrl" style="width:70%;" />
        </div>
      </div>
     
    </div>
     <Loading v-if="loading" />
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import Loading from "@/components/ui/Loading.vue";
import mixin from "@/components/shared/mixinUtility";
export default {
  name: "IdentityClient",
  props: ["contact"],
  mixins: [mixin],
  data() {
    return {
      loading: false,
      gbgData: { imageUrl: "", linkUrl: "" , sessionId: "" , status: "" },
      statusInterval: null,
    };
  },
  directives: { mask },
  components: {
    Loading,
  },
  methods: {
    onError(e) {
      console.log("onError", e);
      this.showGenericErrorMessage("We've encountered a problem.", false);
    },
    async checkIDCheckstatus() {
        const gbgData = await this.getIDCheckStatus(this.gbgData.sessionId);
        const status = gbgData.status.toLowerCase();
       
        // Keep refreshing until status is verified
        if (status === "none" || status === "started") return false;
        
        // any other status goes to thank you page
        clearInterval(this.statusInterval); // Stop refreshing once handled
        // Go to the next step
        this.$emit("goNext");
        
    },
  },
  computed: {
    ...mapGetters({
      tabs: "getTabs",
      currentActive: "getCurrentActive",
      formData: "getFormData",
      additionalContactId: "getAdditionalContactId",
    }),
  },
  async created() {
    try {
      this.loading = true;
      var journeyType = "";
      if (this.contact.showIDdoc && this.contact.showPOA) {
      //ID and POA journey
      journeyType = "IDPOA";
    } else if (this.contact.showIDdoc && !this.contact.showPOA) {
      //ID only journey
      journeyType = "ID";
    } else if (!this.contact.showIDdoc && this.contact.showPOA) {
      //POA only journey
      journeyType = "POA";
    }else
    journeyType = "IDPOA";

      const gbgData = await this.createGBGLink(this.contact.contactId,journeyType);
      this.gbgData.imageUrl = gbgData.imageUrl;
      this.gbgData.linkUrl = gbgData.url;
      this.gbgData.sessionId = gbgData.sessionId;
    
      // Start the interval to check status every 6 seconds
        this.statusInterval = setInterval(this.checkIDCheckstatus, 6000);
      this.loading = false;
    } catch (ex) {
      this.loading = false;
      console.log(ex);
    }
   
  },
};
</script>
<style scoped>
.btn-anchor {
  color: white;
  text-decoration: none;
}
btn-anchor:hover {
  color: white;
  text-decoration: none;
}
</style>